import { render, staticRenderFns } from "./MessageRecord.vue?vue&type=template&id=bb4a3cb4&scoped=true"
import script from "./MessageRecord.vue?vue&type=script&lang=js"
export * from "./MessageRecord.vue?vue&type=script&lang=js"
import style0 from "./MessageRecord.vue?vue&type=style&index=0&id=bb4a3cb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4a3cb4",
  null
  
)

export default component.exports